<template>
    <BlocoAccordion
        titulo="Financeiro"
        tema="financeiro"
        subtitulo="1 indicador"
        descricao="Contas pagas, recebidas e saldo do período"
    >
        <PagamentosRecebimentos @updateMes="atualizarMes" :mes="mes" :ano="ano" />
    </BlocoAccordion>
</template>

<script>
import BlocoAccordion from './BlocoAccordion.vue';
import PagamentosRecebimentos from './Graficos/Financeiro/PagamentosRecebimentos.vue';

export default {
    name: 'BlocoFinanceiro',
    components: {
        BlocoAccordion,
        PagamentosRecebimentos,
    },
    props: {
        mes: { required: true },
        ano: { required: true },
    },
    emits: ['updateMes'],
    methods: {
        atualizarMes(mes) {
            this.$emit('updateMes', mes);
        },
    },
};
</script>
